// eslint-disable-next-line import/prefer-default-export
export const COEF = 1.5

export const BOND_REPOSITORY_NAME = 'paiement-caution'
